'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var requestInterceptors = [];
var ignoreHeaderInequality = [];
var cache = [];

function objectKeyEquals(o1, o2) {
    var ignoredKeys = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    if ((typeof o1 === 'undefined' ? 'undefined' : _typeof(o1)) !== 'object' || (typeof o2 === 'undefined' ? 'undefined' : _typeof(o2)) !== 'object' || o1 === null || o2 === null || Object.keys(o1).length !== Object.keys(o2).length) {

        return false;
    }

    return Object.keys(o1).every(function (key) {
        if (_typeof(o1[key]) === 'object' && _typeof(o2[key]) === 'object') {
            return true;
        } else {
            return ignoredKeys.indexOf(key) > -1 || o1[key] === o2[key];
        }
    });
}

function getFromCache(url, requestOptions) {
    var cached = cache.filter(function (instance) {
        return instance.url === url && objectKeyEquals(instance.requestOptions.headers, requestOptions.headers, ignoreHeaderInequality) && objectKeyEquals(instance.requestOptions, requestOptions);
    });
    return cached[0];
}

function removeFromCache(url, requestOptions) {
    var cached = getFromCache(url, requestOptions);
    if (cached) {
        cache.splice(cache.indexOf(cached), 1);
    }
    return cached;
}

// necessary to prevent IE10 and below from caching ajax requests by default
function cacheBustingUrl(url) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return '' + url + separator + 't=' + new Date().getTime();
}

function fetchWithHeaders(url) {
    var additionalRequestOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var requestOptions = {
        headers: Object.assign({
            accept: 'application/json, application/xml'
        }, additionalRequestOptions.headers || {}),
        credentials: 'same-origin'
    };

    delete additionalRequestOptions.headers;

    Object.assign(requestOptions, additionalRequestOptions);

    requestInterceptors.forEach(function (requestInterceptor) {
        Object.assign(requestOptions, requestInterceptor(requestOptions));
    });

    var cached = options.cache && getFromCache(url, requestOptions);
    var cacheBustUrl = options.disableCacheBusting ? url : cacheBustingUrl(url);
    if (cached) {
        if (cached.response) {
            return Promise.resolve(cached.response.clone());
        } else {
            return cached.promise;
        }
    }
    var promise = fetch(cacheBustUrl, requestOptions).then(function (response) {
        if (response.status >= 400) {
            removeFromCache(url, requestOptions);
            return Promise.reject(response);
        }

        if (options.cache) {
            var fromCache = removeFromCache(url, requestOptions);
            cache.push(Object.assign({}, fromCache, { response: response.clone() }));
        }
        return response;
    });
    if (options.cache) {
        cache.push({
            url: url,
            requestOptions: requestOptions,
            promise: promise
        });
    }

    return promise;
}

exports.default = {
    addRequestInterceptors: function addRequestInterceptors(interceptors) {
        var _requestInterceptors;

        if (interceptors.contructor !== Array) {
            interceptors = [interceptors];
        }
        (_requestInterceptors = requestInterceptors).push.apply(_requestInterceptors, _toConsumableArray(interceptors));
    },
    clearRequestInterceptors: function clearRequestInterceptors() {
        requestInterceptors = [];
    },
    addIgnoreHeaderInequalities: function addIgnoreHeaderInequalities(headerNames) {
        if (headerNames.contructor !== Array) {
            headerNames = [headerNames];
        }
        ignoreHeaderInequality.push.apply(ignoreHeaderInequality, _toConsumableArray(headerNames));
    },
    get: function get(url) {
        var additionalRequestOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var requestOptions = Object.assign({
            method: 'GET'
        }, additionalRequestOptions);
        return fetchWithHeaders(url, requestOptions, options);
    },
    getJSON: function getJSON(url) {
        var additionalRequestOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var requestOptions = Object.assign({}, additionalRequestOptions);
        requestOptions.headers = Object.assign({}, additionalRequestOptions.headers, {
            accept: 'application/json'
        });
        return this.get(url, requestOptions, options).then(function (response) {
            return response.json();
        });
    },
    post: function post(url, body) {
        var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var requestOptions = Object.assign({
            method: 'POST',
            body: body
        }, options);

        return fetchWithHeaders(url, requestOptions);
    },
    postJSON: function postJSON(url, body) {
        var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var requestOptions = Object.assign({}, options, {
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        return this.post(url, body, requestOptions);
    },
    delete: function _delete(url) {
        var additionalRequestOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var requestOptions = Object.assign({
            method: 'DELETE'
        }, additionalRequestOptions);
        return fetchWithHeaders(url, requestOptions, options);
    }
};

//# sourceMappingURL=gje-fetch.js.map